import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { Flex } from 'primitives/Flex'

export const DesktopControl = ({
  pos,
  show,
  padding,
  onClick,
  isDisabled
}: {
  pos: 'left' | 'right'
  show: boolean
  padding?: boolean
  onClick: () => void
  isDisabled: boolean
}) => (
  <Flex
    center
    css={{
      position: 'absolute',
      transition: 'opacity 125ms ease-in-out',
      opacity: show ? 1 : 0,
      pointerEvents: show ? 'auto' : 'none',
      top: '49%',
      transform: 'translate(0, -49%)',
      right: pos === 'left' ? '60px' : '10px'
    }}
  >
    <Button
      disabled={isDisabled}
      css={{
        cursor: isDisabled ? 'not-allowed' : 'cursor',
        borderRadius: '50px',
        padding: '0px',
        width: '28px',
        height: '28px',
        backgroundColor: '$gray800',
        opacity: 0.8,
        '&:hover': {
          opacity: 1
        }
      }}
      onClick={onClick}
    >
      <Icon
        icon="Chevron"
        rotate={pos === 'left' ? 180 : 0}
        css={{
          'svg > path.primary.stroke': { stroke: '$gray100' },
          strokeWidth: '3px',
          stroke: 'black',
          width: '14px',
          height: '14px'
        }}
      />
    </Button>
  </Flex>
)
